export const EarItems = [
  {
    S_no: "1",
    Pdt_imag:
      "https://img.tatacliq.com/images/i6/200Wx300H/MP000000004256499_437Wx649H_20200802131809.jpeg",
    Pdt_name: "pTron HBE5 Raptor in-Ear Stereo Sound Wired Headphones with Mic",
    Pdt_Price: "₹1,999/-",
    Pdt_brand: "JBL",
    Pdt_rate: "4.3/5",
    Pdt_description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  },
  {
    S_no: "2",
    Pdt_name: "boAt Bassheads 100 in Ear Wired Earphones with Mic(Black)",
    Pdt_Price: "₹499/-",
    Pdt_imag:
      "https://img.tatacliq.com/images/i6/200Wx300H/MP000000004256499_437Wx649H_20200802131809.jpeg",

    Pdt_brand: "boAt",
    Pdt_rate: "4.1/5",

    Pdt_description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  },
  {
    S_no: "3",
    Pdt_imag:
      "https://img.tatacliq.com/images/i6/200Wx300H/MP000000004256499_437Wx649H_20200802131809.jpeg",

    Pdt_name:
      "boAt Bassheads 102 in Ear Wired Earphones with Mic(Charcoal Black)",
    Pdt_Price: "₹400/-",
    Pdt_brand: "boAt",
    Pdt_rate: "4.3/5",

    Pdt_description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  },
  {
    S_no: "4",
    Pdt_name: "pTron HBE5 Raptor in-Ear Stereo Sound Wired Headphones with Mics",
    Pdt_Price: "₹1799/-",
    Pdt_imag:
      "https://img.tatacliq.com/images/i6/200Wx300H/MP000000004256499_437Wx649H_20200802131809.jpeg",

    Pdt_brand: "boAt",
    Pdt_rate: "4.3/5",

    Pdt_description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  },
  {
    S_no: "5",
    Pdt_name: "pTron HBE5 Raptor in-Ear Stereo Sound Wired",
    Pdt_Price: "₹299/-",
    Pdt_brand: "boAt",
    Pdt_rate: "4.3/5",
    Pdt_description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  },
  {
    S_no: "6",
    Pdt_imag:
      "https://img.tatacliq.com/images/i6/200Wx300H/MP000000004256499_437Wx649H_20200802131809.jpeg",

    Pdt_name:
      "boAt Rockerz 450 Bluetooth On-Ear Headphone with Mic(Luscious Black)",
    Pdt_Price: "₹1500/-",
    Pdt_Brand: "boAt",
    Pdt_rate: "4.3/5",

    Pdt_description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  },
  {
    S_no: "7",
    Pdt_imag:
      "https://img.tatacliq.com/images/i6/200Wx300H/MP000000004256499_437Wx649H_20200802131809.jpeg",

    Pdt_name:
      "JBL C50HI in-Ear Headphones with Mic (Blue,Red) Bluetooth On-Ear ",
    Pdt_Price: "₹42,999/-",
    Pdt_Brand: "JBL",
    Pdt_rate: "4.3/5",

    Pdt_description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  },
  {
    S_no: "8",
    Pdt_imag: "ear.jpg",
    Pdt_name: "pTron HBE5 Raptor in-Ear Stereo Sound Wired Headphones with Mic",
    Pdt_Price: "₹199/-",
    Pdt_Brand: "pTron",
    Pdt_rate: "4.3/5",

    Pdt_description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  },
  {
    S_no: "9",
    Pdt_name: "pTron HBE5 Raptor in-Ear Stereo Sound Wired Headphones with Mic",
    Pdt_rate: "4.3/5",
    Pdt_Brand: "boAT",
    Pdt_Price: "₹19,999/-",
    Pdt_description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum versions of Lorem Ipsum.",
  },
];
